import React from 'react';
// import sections
import Hero from '../components/sections/Hero';
import FeaturesTiles from '../components/sections/FeaturesTiles';
import FeaturesSplit from '../components/sections/FeaturesSplit';
import Cta from '../components/sections/Cta';

const Home = () => {

  return (
    <>
      <Hero className="illustration-section-01" />
      <div id="Nosotros">
        <FeaturesTiles />
      </div>
      <FeaturesSplit invertMobile imageFill className="illustration-section-02" />
      
      <Cta split />
    </>
  );
}

export default Home;